import React, { FC, Suspense } from 'react';
import { AGENT_ROUTES, ORG_CATEGORY_BROKER } from '@trip-ux/constants';
import { Route, Routes } from 'react-router-dom';
import { Progress } from '@trip-ux/components';
import ContactUsPage from './ContactUsPage';
import FaqsPage from './FaqsPage';
import ResourcePage from './ResourceCenter';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';
import { lazyWithChunkRetry } from '@trip-ux/common';
import BlankPage from './BlankPage';

const LandingPage = lazyWithChunkRetry(() => import('./LandingPage'));

export const ExternalRoutes: FC = () => {
  const { config } = useSelector((store: ReduxStore) => ({
    config: store.config
  }));
  const userProfile = useSelector((store: ReduxStore) => store.userProfile);
  const showAdvisorContent = userProfile?.organizationCategory === ORG_CATEGORY_BROKER;

  // Helper to convert absolute paths to relative paths for nested routing
  const getRelativePath = (absolutePath: string): string => {
    // Remove the base external path to get relative path for nested routing
    const basePath = '/external';
    return absolutePath.replace(basePath, '') || '/';
  };

  return (
    <Suspense fallback={<Progress />}>
      <Routes>
        <Route
          path={getRelativePath(AGENT_ROUTES[config.locale].WELCOME)}
          element={<LandingPage screen={'landing'} />}
        />
        <Route
          path={getRelativePath(AGENT_ROUTES[config.locale].FAQS)}
          element={showAdvisorContent ? <BlankPage lang={config.locale} /> : <FaqsPage screen={'faqs'} />}
        />
        <Route
          path={getRelativePath(AGENT_ROUTES[config.locale].CONTACTUS)}
          element={
            showAdvisorContent ? <ContactUsPage screen={'advisorContactUs'} /> : <ContactUsPage screen={'contactUs'} />
          }
        />
        <Route
          path={getRelativePath(AGENT_ROUTES[config.locale].RESOURCE)}
          element={
            showAdvisorContent ? <ResourcePage screen={'advisorResource'} /> : <ResourcePage screen={'resource'} />
          }
        />
        <Route index element={<LandingPage screen={'landing'} />} />
      </Routes>
    </Suspense>
  );
};

ExternalRoutes.displayName = 'ExternalRoutes';
export default ExternalRoutes;
